import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
} from '@angular/material/snack-bar';
import { MaterialModule } from '@fantaz/shared/ui/material';

@Component({
  standalone: true,
  imports: [CommonModule, MaterialModule],
  selector: 'fz-toast-confirmation',
  templateUrl: './toast-confirmation.component.html',
  styleUrls: ['./toast-confirmation.component.scss'],
})
export class PromoCodeToastConfirmationComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private readonly ref: MatSnackBarRef<PromoCodeToastConfirmationComponent>,
  ) {}

  close() {
    this.ref.dismiss();
  }

  accept() {
    this.ref.dismissWithAction();
  }
}
